<template>
  <component
    :is="componentIs"
    class="card-promotion"
    :href="href"
    :targetBlank="item.targetBlank"
    :linkNofollow="item.linkNofollow"
    v-if="item && Object.keys(item).length > 0 && ($config.editMode || isPromotionInDateRange)"
    :class="[classes , `${item.mainCategory==='aftersales'?' card-promotion-aftersales ':' card-promotion-sales '}`]"
    :id="`id-${item.uuid}`"
  >
    <div v-if="$config.editMode && !isPromotionInDateRange"
         class="edit-alert-msg">
      Attention: promotion is expired or future or it was removed
    </div>
    <slot name="select"></slot>
    <div class="card-promotion__img">
      <pg-image
        v-if="isSmall"
        :lazy-src="item.imageMobile | mgnlMedia('url')"
      />
      <picture v-else>
        <source
          media="(min-width:0) and (max-width:640px)"
          :srcset="item.imageMobile | mgnlMedia('url')"
          v-if="item.imageMobile"
        />
        <source
          media="(min-width:641px)"
          :srcset="item.image | mgnlMedia('url')"
        />
        <pg-image
          :lazy-src="item.image | mgnlMedia('url')"
          :alt="item.altImage"
        />
      </picture>
    </div>
    <div class="card-promotion__content">
      <div>
        <p v-if="!isSmall"
           :class="`card-promotion__duration ${item.hideEndDateOnBanner ? 'd-hidden' : ''}` ">
            <msg id="common.card.promo.expiration" />
            {{ item.duration }}
        </p>
        <h3 class="card-promotion__title">{{ item.title }}</h3>
        <p class="card-promotion__text">
          <span v-html="item.text"></span>
        </p>
        <p v-if="!promoMobile" class="card-promotion__cta">
          <msg id="common.card.promo.cta" />
        </p>
      </div>
    </div>
    <i class="icon-plus" aria-hidden="true" v-if="!isSmall"></i>
  </component>
</template>

<script>
import PgButton from "../Button/Button.vue";
import PgImage from "../Image/Image.vue";
import {formatDate}      from "../../filters/datetime"

export default {
  name: "CardPromotion",
  components: {
    PgButton,
    PgImage,
  },
  filters: {
    formatDate
  },
  data: () => ({
    isSelect: false,
    isSmall: false
  }),
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    value: {
      type: [String, Array],
      default: "",
    },
    select: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    }
  },
  computed: {
    promoMobile() {
      return this.$mq === 'small';
    },
    componentIs() {
      let component = "a";

      if (this.select === "direct") {
        component = "label";
      } else if (this.select === "confirm") {
        component = "button";
      }
      return component;
    },
    classes() {
      let selectClass = "";

      if (
        this.$slots.select !== undefined &&
        (this.value === this.item.uuid || this.value.includes(this.item.uuid))
      ) {
        selectClass = "is-selected";
      } else if (this.$slots.select !== undefined) {
        selectClass = "is-not-selected";
      }

      let sizeClass = "";

      switch (this.size) {
        case "sm":
          sizeClass = "card-promotion--sm";
          break;
        case "smh":
          sizeClass = "card-promotion--smh";
          break;
        default:
          sizeClass = "card-promotion--lg";
          break;
      }

      return [sizeClass, selectClass];
    },
    href() {
      let href = this.$options.filters.mgnlLink(this.item.link, "url");
      if (this.select === "direct" || this.select === "confirm") {
        href = false;
      }
      return href;
    },
    isPromotionInDateRange() {
      return !this.item.isFuture && !this.item.isExpired;
    }
  },
  mounted() {
    this.isSelect = this.select === "direct" || this.select === "confirm";

    this.isSmall = this.size === "sm" || this.size === "smh";

    this.item && this.item.uuid && this.$eventHub.emit("cardPromotion:active-promo", `id-${this.item.uuid}`);
  }
};
</script>

<!--<style scoped>
#root > .card-promotion&#45;&#45;lg {
  max-width: 1024px;
}

#root > .card-promotion&#45;&#45;sm {
  max-width: 333px;
}

#root > .card-promotion&#45;&#45;smh {
  max-width: 333px;
}
</style>-->
